import { AdjustmentsHorizontalIcon } from '@heroicons/react/24/solid';
import { Accordion, AccordionBody, AccordionHeader, Button, Checkbox, Drawer } from '@material-tailwind/react';
import { Switch } from '@headlessui/react'
import React, { useContext, useState } from 'react'
import CardCommon from './CardCommon';
import { DataContext } from '../context/DataProvider';
import { useNavigate } from 'react-router-dom';

function FilterSearch() {
  const { data, loading } = useContext(DataContext);
  console.log('ini data')
  console.log(data);

  // console.log('lihat token')
  // console.log(token)

  const navigate = useNavigate();

  const handleCardClick = (jobId) => {
    // Navigate to the detail page with the selected job ID
    navigate(`/detail-loker/${jobId}`);
  }

  const [enabled, setEnabled] = useState(false)
  const [openRight, setOpenRight] = useState(false);

  const openDrawerRight = () => setOpenRight(true);
  const closeDrawerRight = () => setOpenRight(false);

  const [openAcc1, setOpenAcc1] = useState(true);
  const [openAcc2, setOpenAcc2] = useState(true);
  const [openAcc3, setOpenAcc3] = useState(true);
 
  const handleOpenAcc1 = () => setOpenAcc1((cur) => !cur);
  const handleOpenAcc2 = () => setOpenAcc2((cur) => !cur);
  const handleOpenAcc3 = () => setOpenAcc3((cur) => !cur);

  const contentDrawer = (
    <>
    <div className='my-5 px-3'>
    <Accordion open={openAcc1} className='border-b-2'>
      <AccordionHeader onClick={handleOpenAcc1} > Tampilkan berdasarkan </AccordionHeader>
      <AccordionBody>
        <div className="flex w-max gap-4 ">
          <Button variant="filled" >filled</Button>
          <Button variant="filled" >filled</Button>
        </div>
      </AccordionBody>
    </Accordion>

    <Accordion open={openAcc2}  className='border-b-2'>
      <AccordionHeader onClick={handleOpenAcc2}> Tipe Pekerjaan </AccordionHeader>
      <AccordionBody>
        <div className="space-y-2">
          <Checkbox 
          defaultChecked
          ripple={false}
          className="!static rounded-md border-gray-900/20 transition-all hover:before:opacity-0"
          label="full-time" />
          <Checkbox 
          defaultChecked
          ripple={false}
          className="rounded-md border-gray-900/20 transition-all hover:before:opacity-0"
          label="full-time" />
          <Checkbox 
          defaultChecked
          ripple={false}
          className="rounded-md border-gray-900/20 transition-all hover:before:opacity-0"
          label="full-time" />
          <Checkbox 
          defaultChecked
          ripple={false}
          className="rounded-md border-gray-900/20 transition-all hover:before:opacity-0"
          label="full-time" />
          <Checkbox 
          defaultChecked
          ripple={false}
          className="rounded-md border-gray-900/20 transition-all hover:before:opacity-0"
          label="full-time" />
          <Checkbox 
          defaultChecked
          ripple={false}
          className="rounded-md border-gray-900/20 transition-all hover:before:opacity-0"
          label="full-time" />
          <Checkbox 
          defaultChecked
          ripple={false}
          className="rounded-md border-gray-900/20 transition-all hover:before:opacity-0"
          label="full-time" />
          <Checkbox 
          defaultChecked
          ripple={false}
          className="rounded-md border-gray-900/20 transition-all hover:before:opacity-0"
          label="full-time" />
          
        </div>
      </AccordionBody>
    </Accordion>

    <Accordion  className='border-b-2'>
      <AccordionHeader>

<Switch
        checked={enabled}
        onChange={setEnabled}
        className={`${enabled ? 'bg-teal-900' : 'bg-teal-700'}
          relative inline-flex h-[38px] w-[74px] shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}
      >
        <span className="sr-only">Use setting</span>
        <span
          aria-hidden="true"
          className={`${enabled ? 'translate-x-9' : 'translate-x-0'}
            pointer-events-none inline-block h-[34px] w-[34px] transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
        />
      </Switch>

      
      </AccordionHeader>
    </Accordion>

    <Accordion open={openAcc3}  className=''>
      <AccordionHeader onClick={handleOpenAcc3}> Pengalaman </AccordionHeader>
      <AccordionBody>
      <div className="space-y-2">
          <Checkbox 
          defaultChecked
          ripple={false}
          className="!static rounded-md border-gray-900/20 transition-all hover:before:opacity-0"
          label="full-time" />
          <Checkbox 
          defaultChecked
          ripple={false}
          className="rounded-md border-gray-900/20 transition-all hover:before:opacity-0"
          label="full-time" />
          <Checkbox 
          defaultChecked
          ripple={false}
          className="rounded-md border-gray-900/20 transition-all hover:before:opacity-0"
          label="full-time" />
          <Checkbox 
          defaultChecked
          ripple={false}
          className="rounded-md border-gray-900/20 transition-all hover:before:opacity-0"
          label="full-time" />
          
          
        </div>
      </AccordionBody>
    </Accordion>
    </div>
    </>
  )

  // Check if data is undefined before mapping
  if (loading) {
    return <p>Loading...</p>;
  }

  return (
    <>
      <div className='px-7'>
        <Button onClick={openDrawerRight} className='w-full flex items-center gap-4 md:hidden !static'>
          <AdjustmentsHorizontalIcon className="w-4 h-4 text-gray-200 dark:text-gray-200"/>
          Filter
        </Button>
      </div>

      <Drawer placement='right' open={openRight} onClose={closeDrawerRight} className='overflow-auto'>
        {contentDrawer}
      </Drawer>

      <div className='md:grid md:grid-cols-3'>
        {/* Filter */}
        <div className='hidden md:block md:h-screen md:overflow-y-auto md:border-2 md:ml-11'>
          {contentDrawer}
        </div>

        {/* crad */}
        <div className='md:col-span-2 grid md:grid-cols-2 !static mx-7 gap-7'>
         {data.data.map((job) => (
          <div key={job.id} onClick={() => handleCardClick(job.id)}>
          <CardCommon jobData={job}/>
          </div>
         ))}

        </div>
      </div>
    </>
  )
}

export default FilterSearch